export default __webpack_public_path__ + "static/proximanova-regular-woff2-4e0fd7e6feda853052b7660c0b6f0d47.woff2";